// Small runtime helpers for the Sheet component.

/** SSR-safe read of the user's reduced-motion preference, evaluated at call time. */
export function prefersReducedMotion(): boolean {
  return (
    typeof window !== 'undefined' &&
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  );
}
